// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicRightOutlinedSvg from "@fishx/icons-svg/es/asn/PicRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PicRightOutlined = function PicRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicRightOutlinedSvg
  }));
};

PicRightOutlined.displayName = 'PicRightOutlined';
export default React.forwardRef(PicRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PicRightOutlined.js
// module id = 3784
// module chunks = 0